import React from "react";
import { Grid, Card, CardContent, Typography, Box, Container } from "@mui/material";

const features = [
  {
    text: "We dig deep into your business to cook up the perfect concept",
    icon: "/img/icons/timer.png",
  },
  {
    text: "We make it super user-friendly so you don’t lose folks along the way.",
    icon: "/img/icons/puzzle.png",
  },
  {
    text: "Our designs are modern and snazzy, keeping users engaged and boosting conversions.",
    icon: "/img/icons/meter.png",
  },
  {
    text: "Expect rock-solid performance for a digital experience that never lets you down.",
    icon: "/img/icons/paint.png",
  },
  {
    text: "We’re all about that smooth integration for workflow zen.",
    icon: "/img/icons/pointer.png",
  },
  {
    text: "We won’t leave you hanging – timely updates to keep your web game strong and stylish.",
    icon: "/img/icons/bar.png",
  },
];

const WebSoftwareFeatures = () => {
  return (
    <Box
      sx={{
        color: "white",
        textAlign: "center",
        py: 6,
        px: 4,
      }}
    >
      <Container>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, color: "white" }}>
          Craft Your Web-Based Software
        </Typography>
        <Typography sx={{ mb: 4, color: "white" }}>
          When you team up with us for web development, you get
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  background:
                    "linear-gradient(to right, #2D30AB, #9D3DBA)",
                  color: "white",
                  textAlign: "left",
                  p: 2,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  boxShadow: 3,
                  height: "100%",
                  justifyContent: "center",
                  minHeight:"100px",
                  maxHeight:"100px",
                  "&:hover": {
                    background: "linear-gradient(to right, #9D3DBA, #2D30AB)",
                  },
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Typography  sx={{ color: "#fff",fontSize:"16px" }}>
                    {feature.text}
                  </Typography>
                </CardContent>
                <Box sx={{ color: "#fff" }}>
                  {/* Render image */}
                  <img src={feature.icon} alt="Feature icon" style={{ width: 100, height: 60 }} />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WebSoftwareFeatures;
